import React, { use, useEffect, useRef, useState } from 'react';
import { Box, Grid, Typography, Button, Modal, Paper, IconButton, Chip, Tooltip, CircularProgress, TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Divider, Select as MuiSelect, MenuItem as MuiMenuItem } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Select from 'react-select'
import TableSelBox from '../commons/TableSelBox';
import CustomTextField from '../commons/CustomTextField';
import { useParams } from 'react-router-dom';
import { store } from '../redux/store';
import * as patientAction from '../redux/actions/patientActions';
import { useDispatch, useSelector } from 'react-redux';
import { range } from '../utils/range';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import * as hospitalActions from '../redux/actions/hospitalActions';
import moment from 'moment';
import { API } from '../api/api';
import { useToast } from "../context/ToastContext";
import CreatableSelect from 'react-select/creatable';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

const getModalStyle = (isMobile) => ({
    position: 'absolute',
    top: isMobile ? '2%' : '50%',
    left: '50%',
    transform: isMobile ? 'translateX(-50%)' : 'translate(-50%, -50%)',
    width: isMobile ? '96%' : { lg: '60%', xl: '55%', md: '65%' },
    maxWidth: isMobile ? '96vw' : undefined,
    maxHeight: isMobile ? '96vh' : '90vh',
    overflowY: 'auto',
    boxSizing: 'border-box',
    bgcolor: '#FFF',
    outline: 'none',
    borderRadius: '10px',
});

const getChildModalStyle = (isMobile) => ({
    ...getModalStyle(isMobile),
    width: isMobile ? '95%' : { xl: '35%', lg: '45%', md: '55%' },
    maxHeight: isMobile ? '90vh' : '85vh',
});

const paperStyle = {
    backdropFilter: "blur(10px)",
    WebkitBackdropFilter: "blur(10px)",
    backgroundColor: 'rgba(255, 255, 255, 0.3)',
    borderRadius: '8px',
    border: "1px solid rgba(211,211,211, 0.10)",
    p: 1,
};

const frequency = ["Once", "Daily", "Several times a day", "Constant"]
const severity = ['Mild', 'Moderate', 'Severe', 'Extremely severe']


function ChildModal({ selectedData, isOpen, handleOpen, handleClose, passedTitle,edit }) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [open, setOpen] = React.useState(false);
    const [inputItem, setInputItem] = useState({})
    const hospitalReducer = useSelector(state => state.hospitalReducer)
    const [list, setList] = useState([])
    const { patientId } = useParams();
    const patientReducer = useSelector(state => state.patientReducer)
    const showToast = useToast()

    useEffect(() => {
        if (selectedData) {
            setInputItem(selectedData)
        }
    }, [selectedData])

    useEffect(() => {
        setOpen(isOpen)
    }, [isOpen])

    useEffect(() => {
        if (passedTitle == "Complaints") {
            store.dispatch(hospitalActions.getComplaintsRequestAction())
        }
        else {
            store.dispatch(hospitalActions.getRisksRequestAction())
        }
    }, [])

    useEffect(() => {
        const complaints = hospitalReducer.complaints || [];
        const risks = hospitalReducer.risks || [];
        const combinedList = [
            ...complaints,
            ...risks
        ];
        setList(combinedList);
    }, [hospitalReducer.complaints, hospitalReducer.risks])

    const handleChange = (field, value) => {
        setInputItem(prevState => {
            const updatedData = { ...prevState };
            // if (String(value).toLowerCase() === 'ongoing') {
            //     updatedData["endWeek"] = null;
            // }
            // else {
            updatedData[field] = value;
            // }
            if (passedTitle == "Complaints") {
                updatedData["status"] = updatedData?.endDate || updatedData?.endWeek ? "ENDED" : "ONGOING"
            }
            updatedData["status"] = updatedData?.status || "ONGOING";
            // updatedData["status"] = updatedData[field]?.status ? updatedData[field].status : updatedData?.endWeek == null ? "ONGOING" : "ENDED";
            return updatedData;
        });
    }

    const handleSubmit = () => {
        const { title, ...dataWithoutTitle } = inputItem
        console.log("inputda", inputItem)
        if (passedTitle == "Complaints") {
            if (inputItem.id) {
                const { title, id, complaintId, isCreatedByPatient, patientId, periods, ...dataUpdateRequest } = inputItem
                store.dispatch(patientAction.updateComplaintRequestAction(patientId, id, {
                    ...dataUpdateRequest
                }))
            }
            else {
                store.dispatch(patientAction.createComplaintRequestAction(patientId, {
                    ...dataWithoutTitle,
                    isAcknowledgedByDoctor: inputItem.isAcknowledgedByDoctor !== undefined ? inputItem.isAcknowledgedByDoctor : true
                }))
            }
        }
        else {
            if (inputItem.id) {
                const { title, id, riskId, isCreatedByPatient, patientId, periods,isConfirmed, ...dataUpdateRequest } = inputItem
                store.dispatch(patientAction.updateRiskRequestAction(patientId, id, {
                    ...dataUpdateRequest
                }))
            }
            else {
                store.dispatch(patientAction.createRiskRequestAction(patientId, {
                    ...dataWithoutTitle,
                    // isAcknowledgedByDoctor: inputItem.isAcknowledgedByDoctor !== undefined ? inputItem.isAcknowledgedByDoctor : true
                }))
            }
        }
        handleClose()
    }

    return (
        <React.Fragment>
            {edit && <Button sx={{ mt: 1, height: { xl: '23px', lg: '29px', md: '29px' }, fontSize: '12px', border: "1px solid #E5E7EB", color: 'black' }} size="small" onClick={() => {
                handleOpen()
                setInputItem({})
            }}>
                Add More +
            </Button>}
            <Modal
                open={open}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
                BackdropProps={{
                    sx: {
                        backdropFilter: 'blur(5px)',
                        backgroundColor: 'rgba(0, 0, 0, 0.2)',
                    }
                }}
            >
                <Box sx={getChildModalStyle(isMobile)}>
                    <Grid container spacing={2} p={{ xs: 2, sm: 3.5 }}>
                        <Grid size={{ xs: 12 }} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Tooltip title="Close">
                                <CloseIcon sx={{
                                    cursor: 'pointer',
                                    fontWeight: 'bold',
                                    '&:hover': {
                                        opacity: 0.5,
                                    },
                                    stroke: 'black',
                                    strokeWidth: 1.5,
                                }} onClick={() => handleClose()} />
                            </Tooltip>
                        </Grid>
                        <Grid size={{ xs: 12 }} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Typography sx={{ fontSize: '14px' }}>
                                <Typography component="span" sx={{ color: '#F56423' }}>
                                    *
                                </Typography>
                                Indicates required fields
                            </Typography>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <Typography sx={{ fontSize: '14px', flexDirection: 'row', display: 'flex' }}>
                                {passedTitle}<Typography sx={{ color: '#F56423' }}>*</Typography>
                            </Typography>
                            <CreatableSelect
                                options={list.map((item) => ({
                                    label: item.title,
                                    value: item.id,
                                }))}
                                placeholder={`Search ${passedTitle}`}
                                value={
                                    inputItem?.title
                                        ? {
                                            label: inputItem.title,
                                            value:
                                                passedTitle === "Complaints"
                                                    ? inputItem?.complaintId
                                                    : inputItem?.riskId,
                                        }
                                        : null
                                }
                                formatCreateLabel={(inputValue) =>
                                    `Create "${inputValue}"`
                                }
                                onChange={(event) => {
                                    if (!event) return;

                                    if (passedTitle === "Complaints") {
                                        handleChange("complaintId", event.value);
                                    } else {
                                        handleChange("riskId", event.value);
                                    }

                                    handleChange("title", event.label);
                                }}
                                onCreateOption={async (inputValue) => {
                                    try {
                                        const endpoint =
                                            passedTitle === "Complaints"
                                                ? "/v1/hospitals/complaints"
                                                : "/v1/hospitals/risks";

                                        const response = await API.post(endpoint, {
                                            title: inputValue,
                                        });
                                        const createdItem = response?.data?.data || response?.data;
                                        if (createdItem?.success == false) {
                                            throw new Error(createdItem.message)
                                        }
                                        const normalizedItem = {
                                            id: createdItem.id,
                                            title: createdItem.title,
                                        };
                                        setList((prev) => [...prev, normalizedItem]);
                                        setInputItem((prev) => ({
                                            ...prev,
                                            title: normalizedItem.title,
                                            ...(passedTitle === "Complaints"
                                                ? { complaintId: normalizedItem.id }
                                                : { riskId: normalizedItem.id }),
                                        }));
                                    } catch (error) {
                                        showToast(`${passedTitle === "Complaints" ? "Complaint" : "Risk"} already Exists`, "error");
                                    }
                                }}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }} sx={{ display: { xs: 'none', sm: 'block' } }} />
                        {/* {patientType === "GYNECOLOGY" ? (
                            <>
                                <Grid size={{ xs: 6 }}>
                                    <Typography sx={{ fontSize: '14px', display: 'flex' }}>
                                        Start Date<Typography sx={{ color: '#F56423' }}>*</Typography>
                                    </Typography>

                                    <TextField
                                        type="date"
                                        fullWidth
                                        value={inputItem?.startDate ? moment(inputItem?.startDate).format('YYYY-MM-DD') : ''}
                                        onChange={(e) => {
                                            handleChange("startDate", moment(e.target.value).toISOString())
                                        }
                                        }
                                        inputProps={{
                                            max: moment().format('YYYY-MM-DD'),

                                        }}
                                        margin="normal"
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            width: '100%',
                                            '& input': {
                                                height: '33px !important',
                                                backgroundColor: '#FFF',
                                                borderRadius: '5px',
                                                boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.15)',
                                            },
                                            '& .MuiInputBase-input': {
                                                padding: '0 12px 0 12px',
                                                fontSize: {
                                                    xl: '13px',
                                                    lg: '12px',
                                                    md: '12px',
                                                },
                                            },

                                            '& .MuiOutlinedInput-root': {
                                                '& fieldset': {
                                                    border: 'none',
                                                },
                                                '&:hover fieldset': {
                                                    border: 'none',
                                                },
                                                '&.Mui-focused fieldset': {
                                                    border: 'none',
                                                },
                                            },
                                        }}
                                    />

                                </Grid>

                                <Grid size={{ xs: 6 }}>
                                    <Typography sx={{ fontSize: '14px', display: 'flex' }}>
                                        End Date
                                    </Typography>


                                    <TextField
                                        type="date"
                                        fullWidth
                                        value={inputItem?.endDate ? moment(inputItem?.endDate).format('YYYY-MM-DD') : ''}
                                        onChange={(e) => {
                                            handleChange("endDate", moment(e.target.value).toISOString())
                                        }
                                        }
                                        inputProps={{
                                            max: moment().format('YYYY-MM-DD'),

                                        }}
                                        margin="normal"
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            width: '100%',
                                            '& input': {
                                                height: '33px !important',
                                                backgroundColor: '#FFF',
                                                borderRadius: '5px',
                                                boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.15)',
                                            },
                                            '& .MuiInputBase-input': {
                                                padding: '0 12px 0 12px',
                                                fontSize: {
                                                    xl: '13px',
                                                    lg: '12px',
                                                    md: '12px',
                                                },
                                            },

                                            '& .MuiOutlinedInput-root': {
                                                '& fieldset': {
                                                    border: 'none',
                                                },
                                                '&:hover fieldset': {
                                                    border: 'none',
                                                },
                                                '&.Mui-focused fieldset': {
                                                    border: 'none',
                                                },
                                            },
                                        }}
                                    />
                                </Grid>
                            </>
                        ) :
                            <>
                                <Grid size={{ xs: 6, sm: 3 }} >
                                    <Typography sx={{ fontSize: '14px', flexDirection: 'row', display: 'flex' }}>
                                        Start Week<Typography sx={{ color: '#F56423' }}>*</Typography>
                                    </Typography>
                                    <TableSelBox
                                        options={range(3, Math.min(40, inputItem?.startWeek > patientReducer?.patientInfo?.currentWeek ? inputItem?.startWeek : patientReducer?.patientInfo?.currentWeek))}
                                        value={inputItem?.startWeek}
                                        setValue={(val) => {
                                            handleChange("startWeek", val)
                                        }}
                                        edit={true}
                                    />
                                </Grid>
                                <Grid size={{ xs: 6, sm: 3 }}>
                                    <Typography sx={{ fontSize: '14px', flexDirection: 'row', display: 'flex' }}>
                                        End Week<Typography sx={{ color: '#F56423' }}>*</Typography>
                                    </Typography>
                                    <TableSelBox
                                        options={range(inputItem?.startWeek || 3, Math.min(40, inputItem?.startWeek > patientReducer?.patientInfo?.currentWeek ? inputItem?.startWeek : patientReducer?.patientInfo?.currentWeek), { ongoing: true })}
                                        value={inputItem?.endWeek || 'ongoing'}
                                        setValue={(val) => {
                                            handleChange("endWeek", val)
                                        }}
                                        edit={true}
                                    />
                                </Grid>
                            </>
                        } */}

                        {/* {passedTitle == "Risk" && <Grid size={{ xs: 6, sm: 3 }}>
                            <Typography sx={{ fontSize: '14px', flexDirection: 'row', display: 'flex' }}>
                                Status<Typography sx={{ color: '#F56423' }}>*</Typography>
                            </Typography>
                            <TableSelBox
                                options={["ONGOING", "ENDED"]}
                                value={inputItem?.status}
                                setValue={(val) => {
                                    handleChange("status", val)
                                }}
                                edit={true}
                            />
                        </Grid>} */}

                        {passedTitle == "Complaints" && <Grid size={{ xs: 12 }}>
                            <Typography sx={{ fontSize: '14px', flexDirection: 'row', display: 'flex' }}>
                                Frequency<Typography sx={{ color: '#F56423' }}>*</Typography>
                            </Typography>
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 0.5 }}>
                                {frequency.map((item, i) => {
                                    return <Chip key={i} label={item} sx={{
                                        backgroundColor: item == inputItem.frequency ? '#FFFF' : '#F5FAFC',
                                        color: "#000000",
                                        fontSize: "12px",
                                    }} onClick={() => handleChange("frequency", item)} />
                                })}
                            </Box>
                        </Grid>}
                        {passedTitle == "Complaints" && <Grid size={{ xs: 12 }}>
                            <Typography sx={{ fontSize: '14px', flexDirection: 'row', display: 'flex' }}>
                                How Severe is it ?<Typography sx={{ color: '#F56423' }}>*</Typography>
                            </Typography>
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 0.5 }}>
                                {severity.map((item, i) => {
                                    return <Chip key={i} label={item} sx={{
                                        backgroundColor: item == inputItem.severity ? '#FFFF' : '#F5FAFC',
                                        color: "#000000",
                                        fontSize: "12px",
                                    }} onClick={() => handleChange("severity", item)} />
                                })}
                            </Box>
                        </Grid>}
                        {passedTitle == "Risk" && <Grid size={{ xs: 12 }}>
                            <Typography sx={{ fontSize: '14px', flexDirection: 'row', display: 'flex', mb: 0.5 }}>
                                Risk Weight (Points)
                            </Typography>
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 0.5 }}>
                                {[1, 2, 3, 4, 5].map((w) => (
                                    <Chip
                                        key={w}
                                        label={`+${w} ${w === 1 ? 'pt' : 'pts'}`}
                                        sx={{
                                            backgroundColor: (inputItem.weight ?? 1) === w ? '#2563EB' : '#F3F4F6',
                                            color: (inputItem.weight ?? 1) === w ? '#FFFFFF' : '#1F2937',
                                            fontWeight: 700,
                                            fontSize: '12px',
                                            cursor: 'pointer',
                                            '&:hover': { opacity: 0.9 },
                                        }}
                                        onClick={() => handleChange("weight", w)}
                                    />
                                ))}
                            </Box>
                        </Grid>}
                        <Grid size={{ xs: 12 }}>
                            <Typography sx={{ fontSize: '14px', flexDirection: 'row', display: 'flex' }}>
                                Remarks <Typography sx={{ color: '#F56423' }}>*</Typography>
                            </Typography>
                            <CustomTextField
                                value={inputItem?.remarks}
                                setValue={(val) => {
                                    handleChange("remarks", val)
                                }}
                                edit={true}
                                rows={3}
                                width='98%'
                            />
                        </Grid>
                        <Grid size={{ xs: 12 }} sx={{ justifyContent: 'flex-end', display: 'flex' }} >
                            <Button
                                variant="contained"
                                onClick={() => handleSubmit()}
                                sx={{ height: '26px', width: '80px', fontSize: '13px', backgroundColor: '#F27704' }}
                                disabled={passedTitle == "Complaints" ? (!(patientReducer?.patientInfo?.patientType === "GYNECOLOGY"
                                    ? inputItem.startDate
                                    : inputItem.startWeek) || !inputItem.status || !inputItem.severity || !inputItem.frequency || !inputItem.title) : (!inputItem.title || !inputItem.remarks)}
                            >
                                Submit
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
        </React.Fragment>
    );
}

function InnerSection({ data, totalDays, type, title, isMobile, isGynecology, patientId ,edit}) {
    console.log("data line 238", data)
    const patientReducer = useSelector(state => state.patientReducer);
    const currentWeek = patientReducer?.patientInfo?.currentWeek
    const [selectedData, setSelectedData] = useState({})
    const [open, setOpen] = useState(false)

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const dispatch = useDispatch();

    const confirmRisk = async (riskId) => {
        await API.post(`/v1/patients/${patientId}/risks/confirm`, {
            riskIds: [riskId],
        });
        dispatch(patientAction.getPatientRisksRequestAction(patientId, "ONGOING"))
    };

    const deleteRisk = async (riskId) => {
        await API.delete(`/v1/patients/${patientId}/risks/${riskId}`);
        dispatch(patientAction.getPatientRisksRequestAction(patientId, "ONGOING"))
    };

    return (
        <>
            {data.map((item, i) => (
                <Box
                    key={item.id}
                    sx={{
                        border: "1px solid #E5E7EB",
                        borderRadius: 3,
                        p: 1,
                        mb: 1,
                        bgcolor: "#F8F8F6",
                        mt: 0.5
                    }}
                >
                    {/*label */}
                    {/* <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, }} sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <Tooltip title={
                            (item.frequency || item.severity) ?
                                <>
                                    Problem: {item.title}
                                    <br />
                                    Frequency: {item.frequency}
                                    <br />
                                    Severity: {item.severity}
                                </>
                                :
                                <>
                                    Problem: {item.title}
                                </>
                        }>
                            <Typography sx={{ px: 1, height: '20px', maxWidth: isMobile ? '100%' : undefined, backgroundColor: '#FFFF', fontSize: { xs: '13px', md: '17px', lg: '16px', xl: '15px' }, textAlign: 'center', borderRadius: '10px', alignSelf: 'center', alignContent: 'center', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden', lineHeight: 1 }}>
                                {item.title}
                            </Typography>
                        </Tooltip>
                        {type == undefined &&
                            <Tooltip title="Edit">
                                <EditIcon sx={{ fontSize: '13px', cursor: 'pointer' }} onClick={() => {
                                    const itemWithoutEndWeek = item.periods ? item.periods.find(item => item.endWeek == null) : isGynecology ? { startDate: item.startDate, endDate: item.endDate } : { "endWeek": item.endWeek, "startWeek": item.startWeek }
                                    setSelectedData({
                                        ...item,
                                        "startWeek": itemWithoutEndWeek?.startWeek || null,
                                        "endWeek": itemWithoutEndWeek?.endWeek || null,
                                        "startDate": itemWithoutEndWeek?.startDate,
                                        "endDate": itemWithoutEndWeek?.endDate
                                    })
                                    setOpen(true)
                                }} />
                            </Tooltip>
                        }
                    </Grid> */}

                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <Box
                            display="flex"
                            alignItems="center"
                            gap={1}
                        >
                            <Typography sx={{ fontSize: { xs: '13px', md: '17px', lg: '16px', xl: '15px' }, textAlign: 'left', fontWeight: '600' }}>
                                {item.title}
                            </Typography>
                            <Chip
                                label={item.isConfirmed ? "Confirmed" : "Unconfirmed"}
                                size="small"
                                sx={{
                                    backgroundColor: item.isConfirmed ? "#DDEBFF" : "#FFE6B8",
                                    color: item.isConfirmed ? "#1E4F9A" : "#7A4B00"
                                }}
                            />
                        </Box>
                        {edit && <Box>
                            {!item.isConfirmed &&
                                <Button
                                    variant="outlined"
                                    size="small"
                                    sx={{
                                        textTransform: "none",
                                        borderRadius: '12px',
                                    }}
                                    onClick={() => {
                                        confirmRisk(item.id)
                                    }}
                                >
                                    Confirm
                                </Button>
                            }
                            <IconButton>
                                {type == undefined &&
                                    <Tooltip title="Delete">
                                        <DeleteIcon sx={{ cursor: 'pointer', fontSize: '20px' }} onClick={() => {
                                            deleteRisk(item.id)
                                        }} />
                                    </Tooltip>
                                }
                            </IconButton>
                            <IconButton>
                                {type == undefined &&
                                    <Tooltip title="Edit">
                                        <EditIcon sx={{ cursor: 'pointer', fontSize: '20px' }} onClick={() => {
                                            const itemWithoutEndWeek = item.periods ? item.periods.find(item => item.endWeek == null) : isGynecology ? { startDate: item.startDate, endDate: item.endDate } : { "endWeek": item.endWeek, "startWeek": item.startWeek }
                                            setSelectedData({
                                                ...item,
                                                "startWeek": itemWithoutEndWeek?.startWeek || null,
                                                "endWeek": itemWithoutEndWeek?.endWeek || null,
                                                "startDate": itemWithoutEndWeek?.startDate,
                                                "endDate": itemWithoutEndWeek?.endDate
                                            })
                                            setOpen(true)
                                        }} />
                                    </Tooltip>
                                }
                            </IconButton>
                        </Box>}
                    </Box>
                    <Box
                        display="flex"
                        flexDirection={'row'}
                        gap={1}
                    >
                        <Typography sx={{ fontSize: { xs: '13px', md: '14px', lg: '14px', xl: '15px' }, textAlign: 'center', }}>
                            Remarks:
                        </Typography>
                        <Typography sx={{ fontSize: { xs: '12px', md: '13px', lg: '13px', xl: '14px' }, textAlign: 'center', }}>
                            {item.remarks}
                        </Typography>
                    </Box>

                    {/* Timeline */}
                    {/* <Grid size={{ xs: 12, sm: 12, md: 6, lg: 10.5 }}>
                        {isMobile ? (
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, pl: 0.5 }}>
                                {(item?.periods ? item.periods : [{ endWeek: item.endWeek, startWeek: item.startWeek }])?.map((range, j) => {
                                    const rangeStart = range.startWeek;
                                    const endWeek = range.endWeek ?? (type === 'past' ? item.endWeek : null);
                                    const isOngoing = type !== 'past' && (endWeek === null || endWeek === undefined);
                                    const displayEnd = isOngoing ? 'ongoing' : (endWeek ?? rangeStart);
                                    return (
                                        <Typography key={j} variant="caption" sx={{ fontSize: '12px', color: 'text.secondary' }}>
                                            Week {rangeStart} – {displayEnd}
                                        </Typography>
                                    );
                                })}
                            </Box>
                        ) : patientReducer.patientInfo.patientType !== "GYNECOLOGY" ? <Box sx={{ position: "relative", height: 4, borderRadius: 4 }}>
                            {(item?.periods ? item.periods : [{ "endWeek": item.endWeek, "startWeek": item.startWeek }])?.map((range, j) => {
                                const rangeStart = range.startWeek;
                                const isOngoing = range.endWeek === null || range.endWeek === undefined;
                                const rangeEnd = isOngoing ? currentWeek : range.endWeek;
                                let width = rangeEnd - rangeStart;
                                if (width === 0) width = 0.4;
                                const leftPercent = ((rangeStart - 2.5) / totalDays) * 100;
                                const widthPercent = ((width) / totalDays) * 100;
                                const redWidth = width == 0.4 ? 1 : 4 * 4;
                                return (
                                    <Box
                                        key={j}
                                        sx={{
                                            position: "absolute",
                                            left: `${leftPercent}%`,
                                            width: `${widthPercent}%`,
                                            height: "100%",
                                            display: "flex",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                width: "8px",
                                                height: "8px",
                                                borderRadius: "50%",
                                                background: 'rgba(118, 221, 232, 1)',
                                                boxShadow: "0 0 4px rgba(0,0,0,0.2)",
                                                zIndex: 2,
                                            }}
                                        />
                                        <Box
                                            sx={{
                                                flexGrow: 1,
                                                height: "4px",
                                                background: 'rgba(118, 221, 232, 1)',
                                                position: "relative",
                                            }}
                                        >
                                            {(item.status == "ENDED" || range.endWeek) && (
                                                <>
                                                    <Box
                                                        sx={{
                                                            position: "absolute",
                                                            right: 0,
                                                            top: 0,
                                                            bottom: 0,
                                                            width: redWidth,
                                                            background: 'rgba(255, 76, 76, 1)',
                                                        }}
                                                    />
                                                    <Box
                                                        sx={{
                                                            position: "absolute",
                                                            right: 0,
                                                            top: "-2px",
                                                            width: "8px",
                                                            height: "8px",
                                                            borderRadius: "50%",
                                                            background: 'rgba(255, 76, 76, 1)',
                                                            boxShadow: "0 0 4px rgba(0,0,0,0.2)",
                                                            zIndex: 2,
                                                        }}
                                                    />
                                                </>
                                            )}
                                        </Box>
                                    </Box>
                                );
                            })}
                        </Box>
                            :
                            (item?.periods ? item.periods : [{ "endDate": item.endDate, "startDate": item.startDate }])?.map((period, index) => (
                                <Box key={index} mt={1} sx={{ display: 'flex', flexDirection: 'row' }}>
                                    <Typography fontSize="13px">
                                        {
                                            period?.startDate
                                                ? moment(period.startDate).format("DD MMM YYYY")
                                                : "-"
                                        }
                                    </Typography>

                                    <Typography fontSize="13px" sx={{ marginLeft: 3 }}>
                                        {
                                            period?.endDate
                                                ? moment(period.endDate).format("DD MMM YYYY")
                                                : "Ongoing"
                                        }
                                    </Typography>
                                </Box>
                            ))}

                    </Grid> */}

                </Box>
            ))}
            {type == undefined && <ChildModal selectedData={selectedData} isOpen={open} handleOpen={handleOpen} handleClose={handleClose} passedTitle={title} edit={edit}/>}
        </>
    )
}

function TrackerSection({ title, handleCloseComplaint, handleCloseRisk, patientType, isMobile,edit }) {
    const isGynecology = patientType == "GYNECOLOGY"
    const days = isGynecology
        ? Array.from({ length: 30 }, (_, i) => {
            const d = new Date();
            d.setDate(d.getDate() - 15 + i);
            return d;
        })
        : Array.from({ length: 38 }, (_, i) => i + 3);
    const totalDays = days.length;
    const { patientId, consultationId } = useParams();
    const patientReducer = useSelector(state => state.patientReducer);
    const [ongoingData, setOngoingData] = useState([])
    const [pastData, setPastData] = useState([])
    const dispatch = useDispatch();
    const sectionRef = useRef(null);
    const [sectionHeight, setSectionHeight] = useState(140);

    useEffect(() => {
        const fetchData = async () => {
            if (!patientId) return;

            if (title === "Complaints") {
                await Promise.all([
                    dispatch(patientAction.getPatientComplaintsRequestAction(patientId, "ONGOING")),
                    dispatch(patientAction.getPatientEndedComplaintsRequestAction(patientId, "ENDED"))
                ]);
            } else {
                await Promise.all([
                    dispatch(patientAction.getPatientRisksRequestAction(patientId, "ONGOING")),
                    dispatch(patientAction.getPatientEndedRisksRequestAction(patientId, "ENDED"))
                ]);
            }
        };

        fetchData();
    }, [patientId, title, dispatch]);

    useEffect(() => {
        const ongoing = [
            ...(patientReducer?.ongoingComplaints || []),
        ];
        const past = [
            ...(patientReducer?.endedComplaints || []),
        ];

        setOngoingData(ongoing);
        setPastData(past);
    }, [
        patientReducer?.ongoingComplaints,
        patientReducer?.endedComplaints,

    ]);

    useEffect(() => {
        const ongoing = [
            ...(patientReducer?.ongoingRisks || [])
        ];
        const past = [
            ...(patientReducer?.endedRisks || [])
        ];

        setOngoingData(ongoing);
        setPastData(past);
    }, [

        patientReducer?.ongoingRisks,
        patientReducer?.endedRisks
    ]);

    useEffect(() => {
        if (sectionRef.current) {
            setSectionHeight(sectionRef.current.offsetHeight);
        }
    }, [ongoingData, pastData]);

    return (
        patientReducer.requestState ? <Box
            sx={{
                width: "100%",
                display: "flex",
                height: sectionHeight,
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <CircularProgress />
        </Box>
            :
            <Box sx={{ mb: 4 }} ref={sectionRef}>
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                    <Typography variant="h6" sx={{ mb: 1, fontSize: { lg: '15px', xl: '16px' } }}>
                        {title}
                    </Typography>
                    <Tooltip title="Close">
                        <CloseIcon sx={{
                            fontSize: '15px',
                            cursor: 'pointer',
                            fontWeight: 'bold',
                            '&:hover': {
                                opacity: 0.5,
                            },
                            stroke: 'black',
                            strokeWidth: 1.5,
                        }} onClick={() => {
                            if (title == "Complaints") {
                                handleCloseComplaint()
                            }
                            else {
                                handleCloseRisk()
                            }
                        }} />
                    </Tooltip>
                </Box>

                {/* Timeline header — hidden on mobile (week labels shown per row instead) */}
                {!isMobile && (
                    <Grid container spacing={1}>
                        <Grid size={{ xs: 12, sm: 12, md: 2, lg: 1.5 }} alignSelf={'center'}>
                            <Typography sx={{ width: '60px', height: '20px', backgroundColor: 'rgba(221, 238, 253, 1)', fontSize: '13px', textAlign: 'center', borderRadius: '10px', alignSelf: 'center', alignContent: 'center' }}>
                                Ongoing
                            </Typography>
                        </Grid>
                        {/* <Grid size={{ xs: 12, sm: 12, md: 10, lg: 10.5 }} >
                        {!isGynecology ? <Box sx={{ display: "flex" }}>
                            {days.map((day) => (
                                <Box key={day} sx={{ flex: 1, textAlign: 'end', mr: 0.1 }}>
                                    <Typography variant="caption" fontSize={{ md: '10px', xl: '13px', lg: '12px' }}> {isGynecology
                                        ? moment(day).format("DD")
                                        : day}</Typography>
                                </Box>
                            ))}

                        </Box> :
                            <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                                <Typography fontSize="13px">
                                    Start Date
                                </Typography>

                                <Typography fontSize="13px" sx={{ marginLeft: 5 }}>
                                    End Date
                                </Typography>
                            </Box>
                        }
                    </Grid> */}
                    </Grid>
                )}
                {isMobile && (
                    <Typography sx={{ width: '60px', height: '20px', mb: 1, backgroundColor: 'rgba(221, 238, 253, 1)', fontSize: '13px', textAlign: 'center', borderRadius: '10px' }}>
                        Ongoing
                    </Typography>
                )}

                {/* Timeline rows */}
                <InnerSection data={ongoingData} totalDays={totalDays} title={title} isMobile={isMobile} isGynecology={isGynecology} patientId={patientId} edit={edit}/>

                {/* past data  */}
                <Grid container spacing={1} mt={1}>
                    <Grid size={{ xs: 12, sm: 12, md: 3, lg: 1.5 }}>
                        <Typography sx={{ width: '44px', height: '20px', px: 0.5, backgroundColor: 'rgba(221, 238, 253, 1)', fontSize: '13px', textAlign: 'center', borderRadius: '10px', alignSelf: 'center', alignContent: 'center' }}>
                            Past
                        </Typography>
                    </Grid>

                </Grid>

                {/* Timeline rows */}
                <InnerSection data={pastData} totalDays={totalDays} type="past" title={title} isMobile={isMobile} isGynecology={isGynecology} patientId={patientId}edit={edit}/>
            </Box>
    );
}

const getRiskWeight = (item) => {
    if (item?.weight !== undefined && item?.weight !== null && !isNaN(Number(item.weight))) {
        return Number(item.weight);
    }
    if (item?.remarks) {
        const match = item.remarks.match(/\(\+?(\d+)\s*(?:pts?|points?|score)?\)/i);
        if (match) return parseInt(match[1], 10);
        const match2 = item.remarks.match(/\[weight:\s*(\d+)\]/i);
        if (match2) return parseInt(match2[1], 10);
    }
    const title = (item?.title || "").toLowerCase();
    // High-impact conditions (Weight: 4)
    if (
        title.includes("pe/htn") ||
        title.includes("pre-eclampsia") ||
        title.includes("preeclampsia") ||
        title.includes("vte") ||
        title.includes("thrombosis") ||
        title.includes("gdm") ||
        title.includes("diabetes") ||
        title.includes("prev cs") ||
        title.includes("caesarean") ||
        title.includes("placenta") ||
        title.includes("aph") ||
        title.includes("pprom") ||
        title.includes("prom") ||
        title.includes("preterm birth")
    ) {
        return 4;
    }
    // Moderate risk factors (Weight: 2)
    if (
        title.includes("obesity") ||
        title.includes("bmi") ||
        title.includes("anaemia") ||
        title.includes("anemia") ||
        title.includes("chronic hypertension") ||
        title.includes("multiple pregnancy") ||
        title.includes("rpl") ||
        title.includes("recurrent") ||
        title.includes("fibroid") ||
        title.includes("thyroid") ||
        title.includes("family")
    ) {
        return 2;
    }
    // Baseline / Mild factors (Weight: 1)
    return 1;
};

const getRiskCategory = (item) => {
    const title = (item?.title || "").toLowerCase();
    if (title.includes("age") || title.includes("multiparity") || title.includes("smoking")) return "Demographic";
    if (title.includes("bmi") || title.includes("obesity") || title.includes("underweight") || title.includes("bp")) return "Vitals / BMI";
    if (title.includes("anaemia") || title.includes("thyroid") || title.includes("gbs") || title.includes("uti")) return "Lab Test";
    return "Condition";
};

const getTierFromScore = (score) => {
    if (score > 7) return "HIGH";
    if (score >= 4) return "MEDIUM";
    return "LOW";
};

const getSeverityTheme = (tierOrScore) => {
    let tier = "LOW";
    if (typeof tierOrScore === "number") {
        tier = getTierFromScore(tierOrScore);
    } else if (typeof tierOrScore === "string") {
        tier = tierOrScore.toUpperCase();
    }

    if (tier === "HIGH") return { tier: "HIGH", label: "High Risk", shortLabel: "High", bg: "#FEE2E2", text: "#991B1B", border: "#F87171" };
    if (tier === "MEDIUM") return { tier: "MEDIUM", label: "Medium Risk", shortLabel: "Medium", bg: "#FEF3C7", text: "#92400E", border: "#FBBF24" };
    return { tier: "LOW", label: "Low Risk", shortLabel: "Low", bg: "#D1FAE5", text: "#065F46", border: "#34D399" };
};

function RiskWeightedTableSection({ handleCloseRisk, patientType, isMobile, edit }) {
    const { patientId } = useParams();
    const patientReducer = useSelector((state) => state.patientReducer);
    const dispatch = useDispatch();

    const [openAddModal, setOpenAddModal] = useState(false);
    const [selectedData, setSelectedData] = useState({});

    const ongoingRisks = patientReducer?.ongoingRisks || [];
    const patientInfo = patientReducer?.patientInfo;

    useEffect(() => {
        if (!patientId) return;
        dispatch(patientAction.getPatientRisksRequestAction(patientId, "ONGOING"));
        dispatch(patientAction.getPatientEndedRisksRequestAction(patientId, "ENDED"));
    }, [patientId, dispatch]);

    const confirmedScore = ongoingRisks
        .filter((r) => r.isConfirmed)
        .reduce((sum, r) => sum + getRiskWeight(r), 0);

    const unconfirmedRisks = ongoingRisks.filter((r) => !r.isConfirmed);
    const unconfirmedScore = unconfirmedRisks.reduce((sum, r) => sum + getRiskWeight(r), 0);
    const projectedScore = confirmedScore + unconfirmedScore;

    const savedTier = localStorage.getItem(`patient_confirmed_tier_${patientId}`) || patientInfo?.riskLevel;
    const [confirmedTier, setConfirmedTier] = useState(savedTier ? savedTier.toUpperCase() : "LOW");

    useEffect(() => {
        if (patientInfo?.riskLevel) {
            setConfirmedTier(patientInfo.riskLevel.toUpperCase());
        }
    }, [patientInfo?.riskLevel]);

    const tierRank = { LOW: 1, MEDIUM: 2, HIGH: 3 };
    const targetTier = getTierFromScore(projectedScore);

    const isEscalating = tierRank[targetTier] > tierRank[confirmedTier] || (unconfirmedRisks.length > 0 && targetTier !== 'LOW');

    const currentSeverity = getSeverityTheme(confirmedTier);
    const projectedSeverity = getSeverityTheme(targetTier);

    const confirmRisk = async (riskId) => {
        await API.post(`/v1/patients/${patientId}/risks/confirm`, {
            riskIds: [riskId],
        });
        dispatch(patientAction.getPatientRisksRequestAction(patientId, "ONGOING"));
    };

    const confirmEscalation = async () => {
        const riskIds = unconfirmedRisks.map((r) => r.id);
        if (riskIds.length > 0) {
            await API.post(`/v1/patients/${patientId}/risks/confirm`, {
                riskIds,
                confirmAll: true,
            });
            dispatch(patientAction.getPatientRisksRequestAction(patientId, "ONGOING"));
        }
        try {
            await API.patch(`/v1/patients/${patientId}`, {
                riskLevel: targetTier,
            });
        } catch (err) {
            console.error("Error updating patient riskLevel", err);
        }
        localStorage.setItem(`patient_confirmed_tier_${patientId}`, targetTier);
        setConfirmedTier(targetTier);
        dispatch(patientAction.getPatientDetailsRequestAction(patientId, true));
    };

    const deleteRisk = async (riskId) => {
        await API.delete(`/v1/patients/${patientId}/risks/${riskId}`);
        dispatch(patientAction.getPatientRisksRequestAction(patientId, "ONGOING"));
    };

    const handleUpdateWeight = (riskId, newWeight) => {
        dispatch(patientAction.updateRiskRequestAction(patientId, riskId, { weight: newWeight }));
    };

    return (
        <Box sx={{ p: { xs: 1.5, sm: 2.5 } }}>
            {/* Header with Dynamic Score & Badge */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 2, borderBottom: '1px solid #E5E7EB' }}>
                <Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Typography variant="h6" sx={{ fontWeight: 700, fontSize: { xs: '15px', sm: '18px' } }}>
                            Risk Assessment &amp; Weighted Scoring
                        </Typography>
                        {patientInfo?.currentWeek && (
                            <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '12px' }}>
                                (Week {patientInfo.currentWeek})
                            </Typography>
                        )}
                    </Box>
                    <Typography variant="caption" sx={{ color: '#9CA3AF' }}>
                        Clinical risk evaluation with weighted scoring &amp; escalation confirmation
                    </Typography>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <Box sx={{ textAlign: 'right' }}>
                        <Typography variant="caption" sx={{ fontSize: '10px', textTransform: 'uppercase', color: '#6B7280', fontWeight: 600, display: 'block' }}>
                            Current Score
                        </Typography>
                        <Typography sx={{ fontWeight: 800, fontSize: '15px', color: currentSeverity.text }}>
                            Score: {confirmedScore}
                        </Typography>
                    </Box>

                    <Chip
                        label={currentSeverity.label}
                        size="small"
                        sx={{
                            backgroundColor: currentSeverity.bg,
                            color: currentSeverity.text,
                            border: `1px solid ${currentSeverity.border}`,
                            fontWeight: 700,
                            textTransform: 'uppercase',
                            fontSize: '11px',
                            px: 0.5,
                        }}
                    />

                    <IconButton
                        size="small"
                        onClick={handleCloseRisk}
                        sx={{ ml: 1, color: '#4B5563', '&:hover': { bgcolor: '#F3F4F6' } }}
                    >
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </Box>
            </Box>

            {/* Dynamic Escalation Banner when escalation is detected */}
            {isEscalating && (
                <Box
                    sx={{
                        mt: 2,
                        p: 1.5,
                        borderRadius: 2,
                        bgcolor: '#F8FAFC',
                        border: '1px solid #E2E8F0',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        flexWrap: 'wrap',
                        gap: 1.5,
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                        <Typography sx={{ fontSize: '12.5px', color: '#1E293B', fontWeight: 600 }}>
                            Risk Escalation Detected: Confirming will update risk from{' '}
                            <strong>{currentSeverity.shortLabel} ({confirmedScore})</strong> &rarr;{' '}
                            <strong style={{ color: projectedSeverity.text }}>{projectedSeverity.shortLabel} ({projectedScore})</strong>
                        </Typography>
                    </Box>
                    <Button
                        variant="contained"
                        size="small"
                        onClick={confirmEscalation}
                        sx={{
                            textTransform: 'none',
                            borderRadius: '8px',
                            fontSize: '11.5px',
                            fontWeight: 700,
                            bgcolor: '#2563EB',
                            '&:hover': { bgcolor: '#1D4ED8' },
                            px: 2,
                            py: 0.5,
                            boxShadow: 'none',
                            whiteSpace: 'nowrap',
                        }}
                    >
                        Confirm Escalation ({currentSeverity.shortLabel} &rarr; {projectedSeverity.shortLabel})
                    </Button>
                </Box>
            )}

            {/* Loading State */}
            {patientReducer?.requestState ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                    <CircularProgress size={32} />
                </Box>
            ) : (
                <Box sx={{ mt: 2 }}>
                    {/* 2-Column Table Structure: Risk & Weights */}
                    <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid #E5E7EB', borderRadius: 2 }}>
                        <Table size="small">
                            <TableHead sx={{ bgcolor: '#F9FAFB' }}>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 700, fontSize: '11px', textTransform: 'uppercase', color: '#4B5563', py: 1.2 }}>
                                        Risk
                                    </TableCell>
                                    <TableCell align="right" sx={{ fontWeight: 700, fontSize: '11px', textTransform: 'uppercase', color: '#4B5563', py: 1.2 }}>
                                        Weights
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {ongoingRisks.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={2} align="center" sx={{ py: 3, color: '#9CA3AF', fontSize: '12px' }}>
                                            No ongoing risks recorded for this patient.
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    ongoingRisks.map((item) => {
                                        const weight = getRiskWeight(item);
                                        const category = getRiskCategory(item);
                                        const isCond = category === 'Condition';

                                        return (
                                            <TableRow
                                                key={item.id}
                                                sx={{
                                                    bgcolor: '#FFFFFF',
                                                    borderLeft: item.isConfirmed ? 'none' : '4px solid #94A3B8',
                                                    '&:hover': { bgcolor: '#F8FAFC' },
                                                }}
                                            >
                                                <TableCell sx={{ py: 1.2 }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 1 }}>
                                                        <Box sx={{ flex: 1 }}>
                                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                                                                <Typography sx={{ fontWeight: 600, fontSize: '13px', color: '#1F2937' }}>
                                                                    {item.title}
                                                                </Typography>
                                                                <Chip
                                                                    label={category}
                                                                    size="small"
                                                                    sx={{
                                                                        fontSize: '10px',
                                                                        height: '18px',
                                                                        bgcolor: '#F3F4F6',
                                                                        color: '#4B5563',
                                                                        fontWeight: 500,
                                                                    }}
                                                                />
                                                                {item.isConfirmed ? (
                                                                    <Chip
                                                                        label="Confirmed"
                                                                        size="small"
                                                                        sx={{
                                                                            bgcolor: '#D1FAE5',
                                                                            color: '#065F46',
                                                                            border: '1px solid #A7F3D0',
                                                                            fontSize: '9.5px',
                                                                            fontWeight: 700,
                                                                            height: '18px',
                                                                        }}
                                                                    />
                                                                ) : (
                                                                    <Chip
                                                                        label="Pending Review"
                                                                        size="small"
                                                                        sx={{
                                                                            bgcolor: '#F3F4F6',
                                                                            color: '#4B5563',
                                                                            border: '1px solid #E5E7EB',
                                                                            fontSize: '9.5px',
                                                                            fontWeight: 600,
                                                                            height: '18px',
                                                                        }}
                                                                    />
                                                                )}
                                                            </Box>

                                                            {item.remarks && (
                                                                <Typography sx={{ fontSize: '11px', color: '#6B7280', mt: 0.3 }}>
                                                                    {item.remarks}
                                                                </Typography>
                                                            )}
                                                        </Box>

                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8, flexShrink: 0 }}>
                                                            {!item.isConfirmed && (
                                                                <Button
                                                                    variant="contained"
                                                                    size="small"
                                                                    onClick={() => confirmRisk(item.id)}
                                                                    sx={{
                                                                        textTransform: 'none',
                                                                        borderRadius: '6px',
                                                                        fontSize: '11px',
                                                                        fontWeight: 700,
                                                                        bgcolor: '#2563EB',
                                                                        '&:hover': { bgcolor: '#1D4ED8' },
                                                                        px: 1.2,
                                                                        py: 0.2,
                                                                        minHeight: '24px',
                                                                        boxShadow: 'none',
                                                                    }}
                                                                >
                                                                    Confirm
                                                                </Button>
                                                            )}
                                                            {edit && (
                                                                <Tooltip title="Delete">
                                                                    <IconButton size="small" onClick={() => deleteRisk(item.id)} sx={{ p: 0.3 }}>
                                                                        <DeleteIcon sx={{ fontSize: '15px', color: '#9CA3AF', '&:hover': { color: '#EF4444' } }} />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            )}
                                                        </Box>
                                                    </Box>
                                                </TableCell>

                                                <TableCell align="right" sx={{ py: 1.2, verticalAlign: 'middle', whiteSpace: 'nowrap' }}>
                                                    {edit ? (
                                                        <MuiSelect
                                                            size="small"
                                                            value={weight}
                                                            onChange={(e) => handleUpdateWeight(item.id, Number(e.target.value))}
                                                            sx={{
                                                                height: '26px',
                                                                fontSize: '11px',
                                                                fontWeight: 700,
                                                                bgcolor: '#F3F4F6',
                                                                color: '#374151',
                                                                borderRadius: '8px',
                                                                '.MuiSelect-select': { py: '2px', px: '8px' },
                                                                border: 'none',
                                                                '& fieldset': { border: 'none' },
                                                            }}
                                                        >
                                                            <MuiMenuItem value={1}>+1 pt</MuiMenuItem>
                                                            <MuiMenuItem value={2}>+2 pts</MuiMenuItem>
                                                            <MuiMenuItem value={3}>+3 pts</MuiMenuItem>
                                                            <MuiMenuItem value={4}>+4 pts</MuiMenuItem>
                                                            <MuiMenuItem value={5}>+5 pts</MuiMenuItem>
                                                        </MuiSelect>
                                                    ) : (
                                                        <Chip
                                                            label={`+${weight} ${weight === 1 ? 'pt' : 'pts'}`}
                                                            size="small"
                                                            sx={{
                                                                fontSize: '11px',
                                                                height: '24px',
                                                                fontWeight: 700,
                                                                bgcolor: '#F3F4F6',
                                                                color: '#374151',
                                                                px: 0.5,
                                                            }}
                                                        />
                                                    )}
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    {/* Live Calculation Formula Footer */}
                    <Box
                        sx={{
                            mt: 2,
                            p: 1.5,
                            borderRadius: 2,
                            bgcolor: '#F9FAFB',
                            border: '1px solid #E5E7EB',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            flexWrap: 'wrap',
                            gap: 1,
                        }}
                    >
                        <Typography sx={{ fontSize: '12px', color: '#4B5563' }}>
                            <strong>Confirmed Score Breakdown:</strong>{' '}
                            {ongoingRisks.filter((r) => r.isConfirmed).length === 0
                                ? '0 (No confirmed risks)'
                                : ongoingRisks
                                      .filter((r) => r.isConfirmed)
                                      .map((r) => `${getRiskWeight(r)} (${r.title})`)
                                      .join(' + ') + ` = ${confirmedScore} (${currentSeverity.label})`}
                        </Typography>

                        {edit && (
                            <Button
                                variant="outlined"
                                size="small"
                                startIcon={<AddIcon sx={{ fontSize: '14px' }} />}
                                onClick={() => {
                                    setSelectedData({});
                                    setOpenAddModal(true);
                                }}
                                sx={{
                                    textTransform: 'none',
                                    borderRadius: '8px',
                                    fontSize: '11px',
                                    fontWeight: 600,
                                    borderColor: '#D1D5DB',
                                    color: '#374151',
                                }}
                            >
                                Add Risk
                            </Button>
                        )}
                    </Box>
                </Box>
            )}

            {/* ChildModal for adding custom risks */}
            <ChildModal
                selectedData={selectedData}
                isOpen={openAddModal}
                handleOpen={() => setOpenAddModal(true)}
                handleClose={() => setOpenAddModal(false)}
                passedTitle="Risk"
                edit={edit}
            />
        </Box>
    );
}

function TrackerContainer({ type, handleCloseComplaint, handleCloseRisk, patientType, isMobile, edit }) {
    if (type === "Risk") {
        return (
            <RiskWeightedTableSection
                handleCloseRisk={handleCloseRisk}
                patientType={patientType}
                isMobile={isMobile}
                edit={edit}
            />
        );
    }
    return (
        <Box sx={{ p: { xs: 1, sm: 1.5 }, borderRadius: '10px', height: '100%' }}>
            <TrackerSection title={type} handleCloseComplaint={handleCloseComplaint} handleCloseRisk={handleCloseRisk} patientType={patientType} isMobile={isMobile} edit={edit}/>
        </Box>
    );
}

export default function BasicModal({ open, type, handleCloseComplaint, handleCloseRisk, patientType ,edit}) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    return (
        <Modal
            open={open}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            BackdropProps={{
                sx: {
                    backdropFilter: 'blur(5px)',
                }
            }}
        >
            <Box sx={getModalStyle(isMobile)}>
                <TrackerContainer type={type} handleCloseComplaint={handleCloseComplaint} handleCloseRisk={handleCloseRisk} patientType={patientType} isMobile={isMobile} edit={edit}/>
            </Box>
        </Modal>
    );
}
